<template>
  <div class="app-esim-swap-wrapper">
    <SimonModal
      :is-visible="showModal"
      id="substitute-sim-modal"
      @hide="showModal = false"
    >
      <template v-slot:modalTitle>
        <slot name="headerModal"></slot>
      </template>
      <slot name="contentModal"></slot>
    </SimonModal>
    <div class="badge-new">
      <slot name="badge"></slot>
    </div>
    <slot name="cardImg"></slot>
    <dyn-slot :slot-data="slotData" v-if="isEsimFree">
      <slot name="headerFree"></slot>
    </dyn-slot>
    <slot name="header" v-else></slot>
    <div class="card-copytext">
      <dyn-slot :slot-data="slotData" v-if="isEsimFree">
        <slot name="msgFree"></slot>
      </dyn-slot>
      <slot name="msg" v-else></slot>
    </div>
    <div class="action-area">
      <button class="text" @click="openInfoModal">
        <slot name="more"></slot>
      </button>
      <span class="eSimNotInstalledTxt" v-if="isEsimNotInstalled">
        <slot name="eSimNotInstalled"></slot>
      </span>
      <OrderEsimBtn :order-target-url="orderTargetUrl" :sim-order-status="simOrderStatus" :pre-order="setOrderData"
                    :disabled="simOrderStatus.orderable === false || isEsimNotInstalled"
                    :available-device-types="availableDeviceTypes">
        <template v-for="slot in possibleChildSlotsFor('Order')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </OrderEsimBtn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import OrderEsimBtn from '@/components/process/generic/SubstituteSimCard/OrderEsimBtn.vue'
import substituteSimCardProducts from '@/mixins/substituteSimCardProducts'
import SimonModal from '@/components/modal/SimonModal.vue'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'EsimSwapCardWrapper',
  components: {
    OrderEsimBtn,
    SimonModal
  },
  data () {
    return {
      showModal: false
    }
  },
  props: {
    orderTargetUrl: {
      type: String,
      default: ''
    },
    simOrderStatus: {
      type: Object,
      default: () => {}
    },
    availableDeviceTypes: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep',
      'setStatusSimType',
      'setSelectedActivationType',
      'setActivationService',
      'setSelectionData',
      'setSkippedSelection'
    ]),
    ...mapMutations('checkoutv2/substituteSim', ['setStep', 'setSimType', 'setSimActivated']),

    ...mapActions('substituteSimCard', [
      'resetSimDefaultState'
    ]),
    openInfoModal: function () {
      this.showModal = true
    },
    setOrderData: function () {
      if (this.showSubstituteSimV2) {
        this.setStep('summary')
        this.setSimType('E_SIM')
        this.setSimActivated(true)
        return
      }
      this.resetSimDefaultState()
      this.setSelectionData({
        simType: 'E_SIM',
        activation: 'PREACTIVATED'
      })
      this.setStatusSimType('E_SIM')
      this.setSelectedActivationType('PREACTIVATED')
      this.setActivationService(true)
      this.setSkippedSelection()
      this.changeStep('summary')
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'eSimInstalled',
      'simCardType'
    ]),
    isEsimNotInstalled () {
      return !this.eSimInstalled && this.simCardType === 'E_SIM'
    },
    slotData: function () {
      return {
        freeReplacementDaysLeft: this.freeSimReplacementDaysLeft,
        freeReplacementLastDate: this.formattedFreeSimReplacementLastDate
      }
    }
  },
  mixins: [
    substituteSimCardProducts(),
    useFeature('showSubstituteSimV2')
  ]
}
</script>
